
import FixitDialog from "../components/FixitDialog.vue";

export default {
    props: {
      model: {
        default: undefined
      },
      closeText: {
        type: String,
        default: 'Avbryt'
      },
      confirmText: {
        type: String,
        default: 'Erstatt handlevogn'
      },
    },
    computed: {
      showCrossSiteDialog() {
        return this.$store.getters["cart/getShowCrossSiteDialog"]
      },
      cartSalon() {
        return this.$store.getters["salon/getSalonById"](this.$store.getters['cart/getSelectedSalon'] || this.$store.getters['cart/getPreviousSelectedSalon'])
      }
    },
    methods: {
      keepChoice() {
        this.$emit('keepSalonChoice')
        this.$store.commit('cart/setShowCrossSiteDialog', false)
      },
      async removeTreatmentsFromCart() {
        const cart = this.$store.getters['cart/getCart']
        await this.$store.dispatch("cart/removeCartTreatments",{
          treatmentIds: cart.treatmentIds,
          siteId: cart.siteId,
          clientUUId: cart.clientUUId,
          nextSiteId: this.$route.query.department ? parseInt(this.$route.query.department) : this.$store.getters['cart/getPreviousSelectedSalon']
        }).then(() => {
          this.$store.commit('cart/setShowCrossSiteDialog', false)
        });
      },
    },
}
